import { render, staticRenderFns } from "./AtendimentoTriagemEditar.vue?vue&type=template&id=65dcf5c5&"
import script from "./AtendimentoTriagemEditar.vue?vue&type=script&lang=js&"
export * from "./AtendimentoTriagemEditar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports